<template>
  <div class="allreports">
    <div v-loading="loading" class="report-form">
      <h4 style="text-align: center; color:#606266"> Run Report </h4>
      <el-form ref="reportsForm" :label-position="labelPosition" :model="reportsForm" label-width="120px">
        <el-form-item label="Report Type:">
          <el-radio-group v-model="reportsForm.reportTypeValue" @change="reportTypeChange">
            <div v-for="item in reportsForm.reportType" :key="item.id">
              <el-radio style="padding-bottom:3px" :label="item.id">{{item.reportTypeName}}</el-radio> <br>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Report Name" >
          <!-- label="Select a Report:" -->
          <el-select v-model="reportsForm.report" placeholder="Select a Report:" style = "width: 95%; ">
            <el-option v-for="item in reportsForm.reports" :key="item.id" :label="item.reportName" :value="item.reportSearchPath">
          </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Effective Date:">
            <el-date-picker type="date" placeholder="Pick a date" value-format="yyyy-MM-dd" v-model="reportsForm.reportDate" style = "width: 40%;" @change="reportDateChange" :clearable=false :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="Program Type:">
          <el-radio-group v-model="reportsForm.programTypeValue">
            <div v-for="(key,value) in reportsForm.programType" :key="value">
              <el-radio  style="padding-bottom:3px" :label="value">{{key}}</el-radio> <br>
            </div>
          </el-radio-group>
        </el-form-item>
          <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c; margin:0 auto; display:block;" @click="onSubmit">Submit</el-button>
      </el-form>
    </div>
    <br>
    <div v-loading="additionalloading" class="report-form">
      <h4 style="text-align: center; color:#606266"> Additional Reports </h4>
      <el-form ref="reportsForm" :label-position="labelPosition" :model="addReportsForm" label-width="120px">
        <el-form-item label="Report Type:">
          <el-radio-group v-model="addReportsForm.reportTypeValue"  @change="addReportTypeChange">
            <div v-for="item in addReportsForm.reportType" :key="item.id">
              <el-radio style="padding-bottom:5px" :label="item.id">{{item.reportTypeName}}</el-radio> <br>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Report Name" >
          <el-select v-model="addReportsForm.report" placeholder="Select a Report:" style = "width: 95%; padding-bottom: 10px">
            <el-option v-for="item in addReportsForm.reports" :key="item.id" :label="item.documentName" :value="item.id">
          </el-option>
          </el-select>
        </el-form-item>
          <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c; margin:0 auto; display:block;" @click="onSubmitAdd">Download</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import HTTP_API from '@/utils/http-api'
import * as cognosLaunch from '../utils/cognoslaunch.js';
import * as dateUtil from '../utils/DateUtil.js';

export default {
  name: 'AllReports',
  data () {
    return {
      date: new Date(),
      lenderId:'',
      currencyCode: '',
      camPassport: '',
      labelPosition: "right",
      loading: false,
      additionalloading: false,
      months: dateUtil.getMonthNames(),
      reportsForm: {
        defaultReportDate: '',
        reportDate: '',
        report: "",
        reports: [],
        programTypeValue: 'B',
        programType: [],
        reportTypeValue: 1,
        reportType: [],
        earliestDate: ''
      },
      addReportsForm: {
        report: "",
        reports: [],
        reportTypeValue: '',
        reportType: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    }
  },
  methods:{
    getAllReportsData(){
      var vm = this
      vm.loading=true;
      HTTP_API.get('/allreports/allreportsdashboard')
      .then(response => {
        vm.reportsForm.reportType = response.data.reportTypes
        vm.reportsForm.programType = response.data.programType
        vm.lenderId = response.data.lenderId
        vm.currencyCode = response.data.prefReportingCurr
        vm.camPassport = response.data.camPassport
        
        vm.getReports(vm.reportsForm.reportType[0].id)
        var yesterday = new Date();
        yesterday.setDate(vm.date.getDate()-1)
        var day = yesterday.getDate();
        if (day < 10){
          day = '0' + day;
        }
        var month = yesterday.getMonth()+1
        if (month < 10){
          month = '0' + month;
        }
        var year = yesterday.getFullYear();
        vm.reportsForm.defaultReportDate = year + '-'+ month + '-'+ day;
        var monthNow =vm.date.getMonth()
        var yearNow = vm.date.getFullYear();
        var dayNow = vm.date.getDate();
        var dateNow = yearNow + '-'+ monthNow + '-'+ dayNow;
        var defaultReportArr = dateNow.split("-");
        vm.reportsForm.earliestDate = new Date(parseInt(defaultReportArr[0], 10) - 1, parseInt(defaultReportArr[1], 10) - 1, 1);
        vm.reportsForm.reportDate = year + '-'+ month + '-'+ day;
        vm.addReportsForm.reportType = response.data.addlReportTypes
        if (vm.addReportsForm.reportType.length != 0){
          vm.addReportsForm.reportTypeValue = response.data.addlReportTypes[0].id
          vm.getAddReports(vm.addReportsForm.reportTypeValue)
        }
        vm.resetAllFlag();
      })
      .catch(function (error) {
        console.log(error.response)
        vm.resetAllFlag();
      })
    },
    getReports(reportTypeId){
      var vm = this
      vm.loading=true;
      HTTP_API.get('/allreports/getreports/' + reportTypeId)
      .then(response => {
        vm.reportsForm.reports = response.data
        vm.reportsForm.report = response.data[0].reportSearchPath
        vm.resetAllFlag();
      })
      .catch(function (error) {
        console.log(error.response)
        vm.resetAllFlag();
      })
    },
    reportDateChange(inputDateStr){
      console.log("date change report")
      console.log(inputDateStr)
      var vm = this
      var inputDate = null;
      if (inputDateStr != null){
        var inputArr = inputDateStr.split("-");
        inputDate = new Date(parseInt(inputArr[0], 10) , parseInt(inputArr[1], 10) - 1, inputArr[2]);
      }
      if (inputDate < vm.reportsForm.earliestDate) {
        this.$message({
          duration: 0,
          showClose: true,
          message: 'Invalid date selected.  Historical data is limited to the prior 12 months..\nPlease select a date on or after '
           + vm.months[vm.reportsForm.earliestDate.getMonth()] + ' ' + vm.reportsForm.earliestDate.getDate() + ', ' + vm.reportsForm.earliestDate.getFullYear()
          + '.\nIf you require data beyond this historical period, please contact your eSecLending Relationship Manager.'
        });
        vm.reportsForm.reportDate = vm.reportsForm.defaultReportDate;
      }
    },
    reportTypeChange(input){
      console.log("report type change    " + input)
      this.getReports(input);
    },
    onSubmit() {
      console.log('submit!');
      console.log(this.reportsForm);
      var reportSearchPath = this.reportsForm.report
      var cam_passport = this.camPassport
      var begin_dt = this.reportsForm.reportDate
      var programType = this.reportsForm.programTypeValue
      var token = sessionStorage.getItem('web-token')
      if (token) {
        cognosLaunch.cognosLaunchInWindow(
          "reportWindow",
          "menubar=no,toolbar=no,status=yes,location=no,resizable=yes,toolbar=0,width=950,height=880,scrollbars=yes",
          "ui.gateway", process.env.VUE_APP_COGNOS_URL, "m_passportID",
          cam_passport, "ui.tool", "CognosViewer",
          "ui.action", "run", "ui.object",
          reportSearchPath, "ui", "h1",
          "p_Lender", this.lenderId, "p_begin_dt", begin_dt,
          "p_program_type", programType, "cv.toolbar",
          false, "cv.header", false
        )
      }else{
        cognosLaunch.logoffCognos();
        setTimeout(() => {
          window.location.href = "/CR/"
        }, 1000)
      }
    },
    addReportTypeChange(input){
      console.log("report type change    " + input)
      this.getAddReports(input);
    },
    getAddReports(reportType){
      var vm = this
      var param = {}
      param.lenderId = vm.lenderId
      param.reportTypeId = reportType
      vm.additionalloading=true;
      HTTP_API.post('/allreports/getadditionalreports/', param)
      .then(response => {
        vm.addReportsForm.reports = response.data
        if (vm.addReportsForm.reports.length != 0){
          vm.addReportsForm.report = response.data[0].id
        }
        vm.additionalloading=false;
      })
      .catch(function (error) {
        console.log(error.response)
        vm.additionalloading=false;
      })
    },
    onSubmitAdd() {
      console.log('submit!');
      console.log(this.addReportsForm);
      var vm = this
      var fileName = ''
      vm.additionalloading=true;

      HTTP_API.get('/allreports/downloadreport/' +  vm.addReportsForm.report,{responseType: 'blob'})
      .then(response => {
        var disposition =response.headers['content-disposition']
        if (disposition && disposition.indexOf('inline') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }

        if (window.navigator.msSaveOrOpenBlob) {
          // IE11
          window.navigator.msSaveOrOpenBlob(response.data, `${fileName}`)
        } else {
          let url = window.URL.createObjectURL(response.data)
          let a = document.createElement('a')

          document.body.appendChild(a)
          a.href = url
          a.download = `${fileName}`
          a.click()
          vm.additionalloading=false;
        }
      })
      .catch(function (error) {
        console.log(error.response)
        vm.additionalloading=false;
      })
    },
    resetAllFlag() {
      this.loading = false
    }
  },
  created() {
   this.getAllReportsData()
  }
}
</script>

<style scoped>
  .report-form {
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    margin-right: 15px;
    margin-left: 15px;
    /* margin-top: 100px; */
    width: 600px;
    /* background: rgba(255, 255, 255, .9); */
    background: #f2f2f2;
    opacity: 0.96;
    border: 2px solid #7cc1eb;
  }

  .allreports{
    display: flex;
    align-items: center;
    flex-direction:column;
  }
</style>
